import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm,FieldArray,change} from 'redux-form'
import SlideWrapper from './slideWrappers/SlideWrapper'
import BodyWrapper from './slideWrappers/BodyWrapper'
import ChoicesWrapper from './slideWrappers/ChoicesWrapper'
import ImageWrapper from './slideWrappers/ImageWrapper'
import Icon from '../misc/Icons'
import * as slideLayoutJSON from './slideLayout/slideLayoutDefinition.json'

const initialChoiceBody='\u2063'
const QUESTION_BODY_MAX_LENGTH=slideLayoutJSON.SpecialValues.BodyMaxCharacterCount
const ChoiceMaxCharacterCount=slideLayoutJSON.SpecialValues.ChoiceMaxCharacterCount
const MAX_NUM_LINE_BREAKS=6


const renderChoiceBodyField = ({ style,input,index,label,disabled, type,changeWithSubmitChoices,setChoiceCorrect,numberOfChoices, meta: { touched, error, warning } }) => {

	function handleChoiceBodyKeyDown(e){
		if(e.which === 13 && !e.shiftKey) {	//prevent line breaks	
			e.preventDefault()
			document.getElementById(`choiceBodyField[${index}]`).blur()
		}

		if(e.which === 13 && e.shiftKey) {			
			setChoiceCorrect(index)
			e.preventDefault()
		}
	}
	let choiceBodyValue=input.value
	if(input.value===initialChoiceBody){
		choiceBodyValue=''
	}


	function onPaste(event) {
	    event.preventDefault()//prevent pasting
    	var newText = (event.originalEvent || event).clipboardData.getData('text/plain')
    	newText = newText.replace(/\r?\n/g, ' ') //remove line breaks

      	// merged the modified pasted text with the existing text
	    var el = event.target
	    var cursorPosStart = el.selectionStart
	    var cursorPosEnd = el.selectionEnd
	    var v = el.value
	    var textBefore = v.substring(0, cursorPosStart)
	    var textAfter  = v.substring(cursorPosEnd, v.length)
	    let mergedText = textBefore + newText + textAfter
	    if(mergedText.length >= ChoiceMaxCharacterCount) {
			mergedText=mergedText.substring(0, ChoiceMaxCharacterCount)
		}
	    el.value=mergedText


	    changeWithSubmitChoices(mergedText,index)

	}
	

	function handleTextAreaChange(e){
		let value =e.target.value
		if(value.length >= ChoiceMaxCharacterCount) {
			e.preventDefault()
			value=value.substring(0, ChoiceMaxCharacterCount)
			e.target.value = value
		}
		changeWithSubmitChoices(e.target.value,index)
	}




	
	return(
		<textarea{...input}
			value={choiceBodyValue} 
			element='textarea'			
			id={`choiceBodyField[${index}]`} 
			className="slide-choice-text" 
			style={style}
			onKeyDown={handleChoiceBodyKeyDown}
			onChange={handleTextAreaChange}
			placeholder='Click here to edit'
			onPaste={onPaste}
			disabled={disabled}
		/>
	
	) 
}

const renderBodyTextArea = ({ updateFontSizes,template,question,input, label, type,handleTextAreaChange,isViewOnly,  meta: { touched, error, warning } }) => {
	function handleTextAreaKeyDown(e){
		if(e.which === 13) {
			const lineBreakCount=question.body.split('\n').length
			if(lineBreakCount>MAX_NUM_LINE_BREAKS){
				e.preventDefault()
			}
		}
	}

	return(
		<BodyWrapper question={question} updateFontSizes={updateFontSizes} template={template}>			
			<textarea {...input}  
				disabled={isViewOnly}
				tabIndex={0}
				id='questionBodyTextArea'
				template={template}
				className={'slide-body'}
				onKeyDown={handleTextAreaKeyDown}
				placeholder='Click here to edit question'				
			/>
		</BodyWrapper>

	)
}



const renderChoices = ({isShuffling, isShufflingStart,	transformScale, change,updateFontSizes,question,choices,template,fields,changeWithSubmitChoices,changeWithSubmitRadio, changeWithSubmitRemoveChoice,changeWithSubmitAddChoice,isSurvey,isViewOnly, meta: { touched, error } }) => {
	let uneditedChoices=false	
	for (var i = 0; i < question.choices.length; i++) {
		if(question.choices[i].body === initialChoiceBody){
			uneditedChoices=true
		}
	}


	function setChoiceCorrect(index){
		change(`choices[${index}].correct`, true)
		changeWithSubmitRadio('false',index)
	}

	function handleRadioOnChange(value,index){
		if(uneditedChoices && index===0){
			change('choices[0].correct', true)
			changeWithSubmitRadio('false',index)

		}else{
			changeWithSubmitRadio(value,index)
		}
	}

	function handleRemoveChoice(fields,index){
		fields.remove(index)
		changeWithSubmitRemoveChoice(index)
	}





	return(
		<ChoicesWrapper isShuffling={isShuffling} isShufflingStart={isShufflingStart} uneditedChoices={uneditedChoices} question={question}	updateFontSizes={updateFontSizes} template={template} choices={question.choices} >
			
			<div className='slide-choices' >  
				{fields.map((field, index) =>{					


					return(

						<div className={`slide-choice choice--${index} ` 
						+ (isSurvey ? 'is--survey ' : '')
						+ (isSurvey ? 'is--survey ' : '')
						+ (choices[index].correct && !isSurvey ? 'choice--correct ' : ' ')
						+ (!choices[index].correct && !isSurvey ? 'choice--incorrect ' : ' ')}						
						key={index}>        

							<div className='slide-choice-letterblock'>
								<Field 
									name={`choices[${index}].correct`} 
									id={`choices${index}`} 
									component='input'
									type='checkbox'
									disabled={(choices[index].correct && !uneditedChoices) || isViewOnly}
									onChange={(e) =>{
										handleRadioOnChange(e.target.value,index)}}
								/>
								<label htmlFor={`choices${index}`} ></label>
								<div style={{transform: `scale(${1/transformScale}) translateX(-50%)`, transformOrigin: 'top left',}} className='slide-choice-letterblock-tooltip--incorrect'>
									Mark Correct
								</div>
							</div>

							<div className='slide-choice-textContainer'>
								<div className="slide-choice-text is--spacer">
									{choices[index].body}
								</div>

								<Field 
									disabled={isViewOnly}
									choice={question.choices[index]}							
									name={`choices[${index}].body`}  
									maxLength={ChoiceMaxCharacterCount}
									className="slide-choice-text"
									component={renderChoiceBodyField} 
									changeWithSubmitChoices={changeWithSubmitChoices}
									index={index}
									setChoiceCorrect={setChoiceCorrect}
								/>
								{transformScale > 0.6 &&
								<div className="slide-choice-text-hints">								
									<div style={{transform: `scale(${1/transformScale})`}} className="slide-choice-text-hint">
										<span className='text-hint--enter'>Press <strong>SHIFT + ENTER</strong> to mark correct.</span>
										<span className='text-hint--enterLast'>Press <strong>SHIFT + ENTER</strong> to mark correct or Choice A will be auto marked correct.</span>
										<span className='text-hint--shuffleLater'>You can shuffle order later.</span>
										<span className='text-hint--enterSwitch'> Press <strong>SHIFT + ENTER</strong> to mark this correct instead.</span>									
										<span className='text-hint--tab'>Press <strong>TAB</strong> to go to next choice</span>
										<span className='text-hint--tabLast'>Press <strong>TAB</strong> to go to Shuffle Choices button</span>									 
									</div>								
								</div>
								}
						

							</div>

							{fields.length>2 && !isViewOnly &&
							<div 
								className='slide-choice-remove'								
								type='button'
								//title='Remove Choice'
								onClick={() => (handleRemoveChoice(fields,index))}>
								<Icon name='close-small' />								
							</div>
							}  
						</div>
					)})}		
			</div>
		</ChoicesWrapper>
	)
}




class EditQuestionForm extends React.Component {
	constructor(){
		super()
		this.onChange=this.onChange.bind(this)
		this.handleTextAreaChange=this.handleTextAreaChange.bind(this)
		this.changeWithSubmitRadio=this.changeWithSubmitRadio.bind(this)
		this.changeWithSubmitChoices=this.changeWithSubmitChoices.bind(this)
		this.changeWithSubmitRemoveChoice=this.changeWithSubmitRemoveChoice.bind(this)
		this.changeWithSubmitAddChoice=this.changeWithSubmitAddChoice.bind(this)
		this.deleteImage=this.deleteImage.bind(this)
	}	

	

	handleTextAreaChange(e){
		let value =e.target.value
		if(value.length >= QUESTION_BODY_MAX_LENGTH) {
			e.preventDefault()
			value=value.substring(0, QUESTION_BODY_MAX_LENGTH)
			e.target.value = value
		}
		this.props.handleBodyOnChange(value)
	}


	onChange(field,e){
		this.setState({[field]:e.target.value})		
	
	}
	//Check this
	changeWithSubmitRadio(value, index) {
		this.props.onChangeSubmit(value, 'radio', index)
		if(value==='false'){
			this.setState({isSurvey:false})
		}
	}

	changeWithSubmitChoices(value, index) {
		this.props.handleChoiceOnChange(value,index)
	}
	changeWithSubmitRemoveChoice(index) {
		this.props.onChangeSubmit(null, 'removeChoice', index)
	}

	changeWithSubmitAddChoice() {
		this.props.onChangeSubmit(null, 'addChoice')
	}

	deleteImage() {
		this.props.onChangeSubmit('', 'image')
	}



	render() {
		const {
			question,
			isSurvey,
			template,			
			uploadingToCloudinary,
			tempImage,
			transformScale,
			isViewOnly
		} = this.props


		const displayWidth=1280*transformScale
		
		return (
			<form>
		
				<SlideWrapper displayWidth={displayWidth} isStatic={false} template={template}>

					<Field 
						isViewOnly={isViewOnly}
						updateFontSizes={this.props.updateFontSizes}
						template={template}
						question={question}
						updateBodyHeight={this.props.updateBodyHeight}
						type='textarea'                    
						name='body'                    
						component={renderBodyTextArea} 
						onChange={(e) =>{this.handleTextAreaChange(e)}}
						onFocus={this.props.onFormFieldFocus}
						onBlur={this.props.onFormFieldBlur}
					/>              

					<ImageWrapper question={question} showImageSearchModal={this.props.showImageSearchModal} disableImageSearch={this.props.disableImageSearch} clearTempImage={this.props.clearTempImage} template={template} image={question.image}  tempImage={tempImage} uploadingToCloudinary={uploadingToCloudinary} deleteImage={this.deleteImage} transformScale={this.props.transformScale}/>					

									
					<FieldArray 
						isViewOnly={isViewOnly}
						updateFontSizes={this.props.updateFontSizes}
						choices={this.props.choices}
						template={template}
						name='choices' 
						question={question}
						component={renderChoices}
						changeWithSubmitChoices={this.changeWithSubmitChoices} 
						changeWithSubmitRadio={this.changeWithSubmitRadio}
						changeWithSubmitRemoveChoice={this.changeWithSubmitRemoveChoice}
						changeWithSubmitAddChoice={this.changeWithSubmitAddChoice}
						isSurvey={isSurvey}						
						change={this.props.change}
						transformScale={this.props.transformScale}
						isShuffling={this.props.isShuffling}
						isShufflingStart={this.props.isShufflingStart}
					/>
	
				</SlideWrapper>
			</form>
		)}

}

const mapStateToProps = (state,ownProps) => {
	if(ownProps.question){
		let body=''
		if(ownProps.question.body !=='Click here to edit question'){ //if question.body is the empty text set body to '' in form so it acts as a placeholder
			body=ownProps.question.body
		}
		return {
			initialValues: {
				body:body,
				image:ownProps.question.image,
				choices:ownProps.question.choices,
			},
		}
	}
}

const FormDecoratedComponent = reduxForm({
	form: 'editQuestionForm',
	enableReinitialize: true,

})(EditQuestionForm)

export default connect(mapStateToProps,{change})(FormDecoratedComponent)



